import { type TFunction } from 'i18next';

const root = 'taxreturns';

export const title = (t: TFunction, key: string) => t(`${root}.title.${key}`);
export const messages = (t: TFunction, key: string) => t(`${root}.messages.${key}`);
